/**
 * used this state to update the global modal state
 *
 */
const state = {
    show: false,
    title: '',
    text: '',
    acceptBtn: { text: '', fn: null },
    declineBtn: { text: '', fn: null },
};

const mutations = {
    SET_MODAL_DATA(state, { title, text, acceptBtn, declineBtn }) {
        state.title = title;
        state.text = text;
        state.declineBtn = declineBtn;
        state.acceptBtn = acceptBtn;

        state.show = true;
    },
    CLEAR_STATE(state) {
        this.commit('GlobalModalStore/SET_MODAL_DATA', {
            title: '',
            text: '',
            acceptBtn: { text: '', fn: null },
            declineBtn: { text: '', fn: null },
        });

        state.show = false;
    },
};

const actions = {
    /**
     *  add async actions here
     */
};

const getters = {
    GET_STATE: (state) => state,
    GET_SHOW_STATE: (state) => state.show,
    GET_TITLE: (state) => state.title,
    GET_TEXT: (state) => state.text,
    GET_ACCEPTBTN: (state) => state.acceptBtn,
    GET_DECLINEBTN: (state) => state.declineBtn,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
